import React from 'react';

interface CheckboxOption {
  label: string;
  value: string;
}

interface CheckboxGroupProps {
  label: string;
  name: string;
  values: string[];
  onChange: (values: string[]) => void;
  options: CheckboxOption[];
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  label,
  name,
  values,
  onChange,
  options,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target;
    if (checked) {
      onChange([...values, value]);
    } else {
      onChange(values.filter((v) => v !== value));
    }
  };

  return (
    <div>
      <span className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        {label}
      </span>
      <div className="space-y-2">
        {options.map((opt) => (
          <label
            key={opt.value}
            className="flex items-center space-x-2 text-sm text-gray-900 dark:text-white"
          >
            <input
              type="checkbox"
              name={name}
              value={opt.value}
              checked={values.includes(opt.value)}
              onChange={handleChange}
              className="w-4 h-4 rounded bg-[#F2F2F2] text-blue-600 
                         focus:ring-2 focus:ring-blue-500 focus:outline-none 
                         dark:bg-gray-700 dark:focus:ring-blue-600"
            />
            <span>{opt.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default CheckboxGroup;

